module.exports = __webpack_public_path__ + "media/images/athletes/1694-57fcd24c9837c117d0eecb12648dfb32.png";